module.exports = __webpack_public_path__ + "static/media/Alert.4eb613ef.wav";